define('vspot-angular/services/org-group-service',[], function () {
    'use strict';

    return ['$http', 'resources.OrgGroup', 'resources.OrgGroupActivity', function ($http, OrgGroup, OrgGroupActivity) {

        return {
            save: function (postData) {
                return OrgGroup.save(postData);
            },

            update: function (postData) {
                return OrgGroup.update(postData);
            },

            delete: function (key) {
                return OrgGroup.delete({id: key});
            },

            uploadImage: function (postData) {
                return OrgGroup.uploadImage(postData);
            },

            removeImage: function (postData) {
                return OrgGroup.removeImage(postData);
            },

            /*
             * Get a list of activityes for a specific group.
             * @param key {int} - the group key
             */
            getActivities: function(key) {
                return OrgGroupActivity.query({group_key: key});
            },

            /*
             *  Adds an activity to a group.
             */
            addActivity: function (activityId, postData) {
                // placed here so that if the name of the variable
                // for activity id changes again, it's easier to replace
                postData.activity_id = activityId;

                return OrgGroupActivity.save(postData);
            },

            /*
             *  Updates the sort order for an activity on a group.
             */
            moveActivity: function (id, sortOrder) {
                return OrgGroupActivity.update({id: id, sort_order: sortOrder});
            },

            /*
             *  Removes an activity from a group
             */
            removeActivity: function (groupActivityId) {
                return OrgGroupActivity.delete({ id: groupActivityId });
            }
        };
    }];
});

